import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, del } from "helpers/api_helper";
import { decrypt, getValuesSocketData } from "helpers/secretManager";
import * as URL from "helpers/url_helper";
import { toast } from "react-toastify";



// Admin

export const adminApi = createAsyncThunk(
    "adminApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await post(URL.GET_ADMIN, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const addAdminApi = createAsyncThunk(
    "addAdminApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.ADD_ADMIN, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            toast.success(response?.message);
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const updateAdminApi = createAsyncThunk(
    "updateAdminApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await put(URL.EDIT_ADMIN + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            toast.success(response?.message);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const deleteAdminApi = createAsyncThunk(
    "deleteAdminApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await del(URL.DELETE_ADMIN + data?._id, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const adminDetailsApi = createAsyncThunk(
    "adminDetailsApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await get(URL.DETAILS_ADMIN + "/" + data?._id,
                {
                    signature,
                    nonce
                });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const adminStatusChangesApi = createAsyncThunk(
    "adminStatusChangesApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await put(URL.STATUS_CHANGE_ADMIN + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const roleActiveListApi = createAsyncThunk(
    "roleActiveListApi",
    async (arg = {}, Thunk) => {
        const { callBack } = arg;
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await get(URL.ROLE_ACTIVE_LIST, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);
